<template>
    <AdaptersDialog
        :listener-id="getListenerId"
        :listener-close-id="getCloseListenerId"
        :header="$t('lang.promocode.modal.main_label')"
        :loading="loading"
        :button-agree-label="$t('lang.main.btn.create')"
        :callback-agree="create"
        :error-message="errorMessage"
    >
        <template #content>
            <div class="grid">
                <div class="col">
                    <div class="field">
                        <label class="required">{{ $t('lang.promocode.modal.name') }}</label>
                        <InputText
                            v-model="model.code"
                            @keyup="onChangeName"
                            :maxlength="20"
                        />
                    </div>
                    <div class="field">
                        <label class="required">{{ $t('lang.promocode.modal.discount') }}</label>
                        <InputNumber
                            v-model="model.discount"
                            @keyup="onKeyupDiscount"
                            :max="maxDiscount"
                            :min="0"
                        />
                    </div>
                    <div class="field">
                        <label>{{ $t('lang.promocode.modal.percent') }}</label>
                        <InputNumber v-model="model.percent" :max="maxDiscount" :min="0" disabled />
                    </div>
                    <p>{{ $t('lang.promocode.modal.info.p1') }}</p>
                    <p>{{ $t('lang.promocode.modal.info.p2') }}</p>
                    <p>{{ $t('lang.promocode.modal.info.p3') }}</p>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import AdaptersDialog from "../../../component/adapters/Dialog.vue";
import {Listeners} from "../../../constants/listeners";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import UserPromoApi from "../../../api/UserPromoApi";
import Alerts from "../../../mixins/Alerts";

export default {
    name: "PartnerCreatePromo",
    mixins: [Alerts],
    data() {
        return {
            loading: false,
            errorMessage: null,
            maxDiscount: 20,
            model: {
                code: '',
                discount: 10,
                percent: 10,
            }
        }
    },
    computed: {
        getListenerId() {
            return Listeners.POPUP_PARTNER_CREATE_PROMO_OPEN;
        },
        getCloseListenerId() {
            return Listeners.POPUP_PARTNER_CREATE_PROMO_CLOSE;
        }
    },
    methods: {
        onKeyupDiscount(e) {
            const discount = e.target.value;
            if (discount < 0 || discount > this.maxDiscount) {
                this.model.percent = 0;
                this.errorMessage = this.$t('lang.promocode.modal.range_error')
                e.preventDefault();
                return;
            }

            this.model.percent = this.maxDiscount - discount;
        },
        create() {
            this.loading = true;
            UserPromoApi
                .create(this.model)
                .then(() => {
                    this.alertSuccess(this.$t('lang.promocode.modal.create_promo_success'));
                    this.$emitter.emit(this.getCloseListenerId);
                    this.$parent.loadPromocodes();
                })
                .catch(error => this.errorMessage = error.message)
                .finally(() => this.loading = false);
        },
        onChangeName(e) {
            this.model.code = e.target.value.replace(/[^a-z0-9-]/gi, '').toLowerCase();
        },
    },
    components: {
        AdaptersDialog,
        InputText,
        InputNumber,
    }
}
</script>
